<template>
    <div class="field">
        <div class="field__label">Data nașterii</div>

        <div class="birthday-select">
            <select id="year" class="birthday-select__input" 
                v-model="selectedYear" 
                @change="updateDays(), isChanged = true, sendDate()">

                <option value="" disabled selected>An</option>
                <option v-for="year in years"
                    :key="'select-' + year.year"
                    :value="year.year"
                    :selected="year == selectedYear">
                    {{ year.year }}
                </option>
            </select>

            <select id="month" class="birthday-select__input" 
                v-model="selectedMonth" @change="updateDays(), isChanged = true, sendDate()">
                
                <option value="" disabled selected>Luna</option>
    			<option v-for="(month, index) in months"
                    :key="month.month"
                    :value="index"
                    :selected="month == selectedMonth">
                    {{ month.month }}
    			</option>
            </select>

            <select id="day" class="birthday-select__input" 
                v-model="selectedDay" @change="isChanged = true, sendDate()">
                
                <option value="" disabled selected>Zi</option>
                <option v-for="day in days"
                    :key="day.day"
                    :value="day.day"
                    :selected="day == selectedDay">
                    {{ day.day }}
                </option>
            </select>
        </div>

        <div class="field__error">{{error}}</div>
    </div>

</template>

<script>
    const defaultMonths = {
        0: 'Ianuarie',
        1: 'Februarie',
        2: 'Martie',
        3: 'Aprilie',
        4: 'Mai',
        5: 'Iunie',
        6: 'Iulie',
        7: 'August',
        8: 'Septembie',
        9: 'Octombrie',
        10: 'Noiembrie',
        11: 'Decembrie'
    }
    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            default: {
                type: String,
                default: '',
                required: false
            },
            min: {
                type: String,
                required: false
            },
            max: {
                type: String,
                required: false
            },
            monthsNames: {
                type: String,
                required: false
            },
            selectClassName: {
                type: String,
                required: false,
                default: 'date-dropdown-select'
            },
            selectDayClassName: {
                type: String,
                required: false,
                default: 'day'
            },
            selectMonthClassName: {
                type: String,
                required: false,
                default: 'month'
            },
            selectYearClassName: {
                type: String,
                required: false,
                default: 'year'
            },
            changed: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                days: [],
                selectedDay: '',
                selectedMonth: '',
                selectedYear: '',
                isChanged: this.changed
            }
        },
        computed: {
            // Returns if there are default date settings.
            initialDate() {
                return !!(this.default || this.min)
            },
            // The date property, converted to a date.
            specifiedDate() {
                return new Date(this.default)
            },
            // The minimum date the will allow user to select.
            minDate() {
                if (this.min) return new Date(this.min)
                return
            },
            // The maximum date the will allow user to select.
            maxDate() {
                if (this.max) return new Date(this.max)
                return
            },
            // Returns a formatted date for backend specific
            calculatedDate() {
                const day = this.selectedDay >= 10 ? this.selectedDay : `0${this.selectedDay}`
                const month = this.selectedMonth + 1 >= 10 ? this.selectedMonth + 1 : `0${this.selectedMonth + 1}`

                return `${this.selectedYear}-${month}-${day}`
            },
            // The alternative names of months
            dividedNamesOfMonths() {
                if (this.monthsNames) return this.monthsNames.replace(/\s/g, '').split(',')
                return
            },
            // Computes a list of month.
            months() {
                let months = []
                for (let i = 0; i < 12; i++) {
                    if (this.dividedNamesOfMonths) months.push(this.dividedNamesOfMonths[i])
                    else months.push(defaultMonths[i])
                }
                return months.map((month, index) => {
                    return { month, selected: index === this.selectedMonth }
                })
            },
            // Computes a list of years.
            years() {
                // Set the first year of the array.
                let firstYear
                if (this.min) {
                    firstYear = this.minDate.getFullYear()
                } else if (this.default) {
                    firstYear = this.specifiedDate.getFullYear()
                } else {
                    firstYear = new Date().getFullYear()
                }
                // Create a range of years to loop through which is either the maximum
                // date minus the first year, or simply 100.
                let through = this.max ? this.maxDate.getFullYear() + 1 - firstYear : 101
                let years = []
                for (let i = firstYear, len = firstYear + through; i < len; i++) years.push(i)
                years.reverse();
                return years.map(year => {
                    return { year, selected: year === this.selectedYear }
                })
            }
        },
        methods: {
            getDays() {
                let days = []
                let daysNumberOfMonth = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate()

                if(this.selectedDay > daysNumberOfMonth)
                    this.selectedDay = daysNumberOfMonth;
                for (let i = 1; i < daysNumberOfMonth + 1; i++) days.push(i)
                return days.map(day => {
                    return { day, selected: days === this.selectedDay }
                })
            },
            updateDays() {
                this.days = this.getDays()
            },
            // Send data to upper component.
            sendDate(forceSend) {
                const date = this.format ? this.format(this.calculatedDate) : this.calculatedDate;
                if(this.selectedYear && this.selectedMonth && this.selectedDay)
                    if(this.isChanged==true || forceSend) {
                        this.$emit('input', date)
                    }
            },
            // Set the initial date.
            setDate(forceSend) {
                // If a value property has been passed to the component, that will be
                // used instead of the current day.
                let date;
                // if (this.min && this.max && !this.default) {
                //     date = new Date(this.min)
                // } else
                if (this.default) {
                    this.updateDays()
                    date = new Date(this.default)

                    if (this.initialDate) this.selectedDay = date.getDate() + 1;
                    else this.selectedDay = date.getDate();
                    this.selectedDay = date.getDate()
                    this.selectedMonth = date.getMonth()
                    this.selectedYear = date.getFullYear()
                    this.sendDate(forceSend)
                }
                // else {
                //     date = new Date()
                // }
            }
        },
        mounted() {
            // Set the date when the component was created
            this.setDate(true);
        },
        updated() {
            // Send the data on change
            this.sendDate()

            // set default values for selector -> SAFARI bug
            // if(date) {
            //     var date = Date(this.default)
            //     this.selectedDay = date.getDate()
            //     this.selectedMonth = date.getMonth()
            //     this.selectedYear = date.getFullYear()
            //
                // this.selectedYear = 2014;
            //     // this.selectedMonth = 2;
            //     // this.selectedDay = 10;
            // }
        },
        watch: {
            default() {
                this.setDate(true);
            }
        }
    }

</script>

<style lang="scss" scoped>

.field{
    width: 100%;
    // max-width: 450px;
    margin: 15px auto auto auto;

    &__label{
        font-weight: 400;
        font-size: 16px;
        margin-bottom: 5px;
        color: $color-main-text;
    }

    &__input-wrapper{
        position: relative;
        height: 45px;

        a{
            position: absolute;
            right: 0px;
            top: -22px;
            text-decoration: none;
            font-size: 12px;
            color: $color-primary;
        }
    }

    &__input-icon{
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translate(0%,-50%);
        font-size: 24px;
        color: $color-main-text;
    }

    &__input{
        box-sizing: border-box;
        width: 100%;
        height: 45px;
        padding-left: 10px;
        border: 1px solid #DDDFE1;
        outline: none;
        color: #464A53;

        &--password{
            position: absolute;
            left: 0px;
            -webkit-appearance:none;
        }
    }


    &__input::placeholder{
        color: $color-placeholder;
    }

    &__input:focus{
        border: 1px solid $color-secondary;
    }

    &__error{
        color: $color-danger;
        font-size: 12px;
        font-family: "Roboto";
        margin-top: 10px;

    }

    &__text{
        display: flex;
        flex-direction: row;
        font-family: "Roboto";
        font-weight: 400;
        font-size: 12px;
        color: $color-primary;
        max-width: 450px;
        margin: 30px auto auto auto;
    }


}

.birthday-select{
    display: flex;
    justify-content: space-between;
    width: 100%;

    &__input{
        width: 30%;
        height: 45px;
        padding-left: 10px;
        border: 1px solid #DDDFE1;
        outline: none;
        color: #464A53;
    }

}
</style>